module.exports = __webpack_public_path__ + "static/img/hussar_aicode_face.54f0bc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/hussar_aicode_face.png
// module id = MZJ2
// module chunks = 0